export const HelpVideoNameMap: { [name in IHelpContexts]: string } = {
  //Ordered by main sidebar icons/screens order
  "email-broadcast": "Email Broadcast Walkthrough",
  dashboard: "Dashboard Walkthrough",
  "all-emails": "All Emails Walkthrough",
  "email-list": "Email List Walkthrough",
  "email-report": "Email Report Walkthrough",
  forms: "Forms Walkthrough",
  "create-new-form": "Create New Form Walkthrough",
  "form-builder": "Form Builder Walkthrough",
  campaign: "Campaign Walkthrough",
  contacts: "Contacts Walkthrough",
  "import-email": "Import Email Walkthrough",
  "manage-tags": "Manage Tags Walkthrough",
  "manage-tags-categories": "Manage Tags Categories Walkthrough",
  "manage-tags-interest-tagging": "Manage Tags Interest Tagging Walkthrough",
  "automation-triggers": "Automation Triggers Walkthrough",
  "settings-general": "Settings - General Walkthrough",
  "settings-contacts": "Settings - Contacts Walkthrough",
  "settings-billing": "Settings - Billing Walkthrough",
  "settings-security": "Settings - Security Walkthrough",
  "settings-apikey": "Settings - Api Key Walkthrough",
  "settings-blocking": "Settings - Blocking Walkthrough",
  "settings-users": "Settings - Users Walkthrough",
  "settings-integrations": "Settings - Integrations Walkthrough",
  "settings-learnistic-integration":
    "Settings - Learnistic Integration Walkthrough",
  "settings-thrivecart-integration":
    "Settings - Thrivecart Integration Walkthrough",
  resend: "Resend Email Walkthrough",
  "general-settings": "General Settings Walkthrough",
  "footer-settings": "Footer Settings Walkthrough",
  "send-from": "Send From Walkthrough",
  "dns-records": "DNS Records Walkthrough",
  "after-purchase-thank-you-page": "After Purchase Thank You Page Walkthrough",
  "getting-started": "Getting Started Walkthrough",
  "manage-saved-searches": "Manage Saved Searches Walkthrough",
  "campaign-builder-beta": "Campaign Builder - Beta Disclaimer",
  "create-new-campaign": "Create New Campaign Walkthrough",
};

export enum IHelpContexts {
  EmailBroadcast = "email-broadcast",
  Dashboard = "dashboard",
  AllEmails = "all-emails",
  EmailList = "email-list",
  EmailReport = "email-report",
  Forms = "forms",
  CreateNewForm = "create-new-form",
  FormBuilder = "form-builder",
  Campaign = "campaign",
  Contacts = "contacts",
  ImportEmail = "import-email",
  ManageTags = "manage-tags",
  ManageTagsCategories = "manage-tags-categories",
  ManageTagsInterestTagging = "manage-tags-interest-tagging",
  AutomationTriggers = "automation-triggers",
  SettingsGeneral = "settings-general",
  SettingsContacts = "settings-contacts",
  SettingsBilling = "settings-billing",
  SettingsSecurity = "settings-security",
  SettingsApiKey = "settings-apikey",
  SettingsBlocking = "settings-blocking",
  SettingsUsers = "settings-users",
  SettingsIntegrations = "settings-integrations",
  SettingsLearnisticIntegration = "settings-learnistic-integration",
  SettingsThrivecartIntegration = "settings-thrivecart-integration",
  Resend = "resend",
  GeneralSettings = "general-settings",
  FooterSettings = "footer-settings",
  SendFrom = "send-from",
  DNSRecords = "dns-records",
  AfterPurchaseThankYouPage = "after-purchase-thank-you-page",
  GettingStarted = "getting-started",
  ManageSavedSearches = "manage-saved-searches",
  CampaignBuilderBeta = "campaign-builder-beta",
  CreateNewCampaign = "create-new-campaign",
}
